module.exports = __webpack_public_path__ + "images/no-task.79b7f77870e21d65fd764de855517cc6.png";